import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-error',
	templateUrl: './error.html'
})
export class ErrorComponent {

	constructor(public activeModal: NgbActiveModal) { }

	ricarica() {
		window.location.reload();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/error/error.ts